export default {
  PORTAL_APP_ID: 'app',
  PORTAL_OVERLAY_ID: 'overlay',
  PORTAL_ID: 'portal',
  PORTAL_POPPER_ID: 'popper',
  PORTAL_NOTIFICATION_ID: 'notification',
};
